import './styles.scss'

// vendor
import '../common/js/simpleValid';
import '../../../node_modules/slick-carousel/slick/slick.min'

// common
import '../../../modules/system/assets/js/framework';

import './header/header';
import './contacts/contacts';
import './category-nav/category-nav';
import './favorite/favorite';
import './main-section/main-section';
import './pagination/pagination';
import './scroll-top-arrow/scroll-top-arrow';
import './instagram-slider/instagram-slider';
import './promo-slider/promo-slider';
import './popup-ad/popup-ad';
import './aside-menu/aside-menu';

import './product/product';
import './product-item/product-item';
import './product-slider/product-slider';

import './feedback-slider/feedback-slider';
import './feedback-list/feedback-list';

import './category/category';
import './category-sort/category-sort';
import './category-filters/category-filters';

import './cart/cart';
import './cart-item/cart-item';

import './popups-mobile/popups-mobile';
import './popups-desktop/popups-desktop';